export const CsrfToken = (controller) => {
  Object.assign(controller, {
    csrfToken: () => ({
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
    }),
  });
};
